/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const HeartActiveIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 17 17'
			style={{
				enableBackground: 'new 0 0 17 17'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
		>
			<path
				d='M11.7.4c-1.5 0-2.9.8-3.7 2-.8-1.2-2.2-2-3.6-2C2 .4.1 2.3.1 4.7c.1 1.8.7 3.6 1.8 5.1C3.7 12 5.7 13.9 8 15.6c2.3-1.7 4.3-3.7 6.1-5.9 1.1-1.5 1.7-3.2 1.8-5.1 0-2.3-1.9-4.2-4.2-4.2z'
				style={{
					opacity: 0.75,
					fill: '#ee2b7b',
					enableBackground: 'new'
				}}
				transform='translate(.5 .5)'
			/>
			<path
				d='M11.7.4c-1.5 0-2.9.8-3.7 2-.8-1.2-2.2-2-3.6-2C2 .4.1 2.3.1 4.7c.1 1.8.7 3.6 1.8 5.1C3.7 12 5.7 13.9 8 15.6c2.3-1.7 4.3-3.7 6.1-5.9 1.1-1.5 1.7-3.2 1.8-5.1 0-2.3-1.9-4.2-4.2-4.2z'
				style={{
					fill: 'none',
					stroke: '#fff'
				}}
				transform='translate(.5 .5)'
			/>
		</svg>
	)
}

export default HeartActiveIcon
